var _style, _g, _defs, _defs2, _g2, _g3, _g4, _defs3, _g5, _g6, _g7, _g8, _defs4, _g9, _g10, _g11, _g12, _defs5, _g13, _g14, _g15, _defs6, _g16, _g17, _g18, _g19, _defs7, _g20, _g21, _g22, _g23, _g24, _defs8, _g25, _g26, _g27, _g28, _g29, _defs9, _g30, _g31, _g32, _g33, _defs10, _g34, _g35, _g36, _g37, _defs11, _g38, _g39, _g40, _g41, _g42, _defs12, _g43, _g44, _g45, _g46, _g47, _defs13, _g48, _g49, _g50, _g51, _defs14, _g52, _g53, _defs15, _g54, _g55, _defs16, _g56, _g57, _defs17, _g58, _g59, _g60;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmileyt03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51 51",
    style: {
      enableBackground: "new 0 0 51 51"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFED00;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:none;stroke:#232323;stroke-miterlimit:10;}\r\n\t.st3{fill:#94C11A;}\r\n\t.st4{fill:#37AA33;}\r\n\t.st5{fill:#F3F2C0;}\r\n\t.st6{fill:#494949;}\r\n\t.st7{fill:#37AA33;stroke:#F3F2C0;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#494949;stroke-miterlimit:10;}\r\n\t.st9{fill:#232323;}\r\n\t.st10{fill:#FFED00;stroke:#F7F4C3;stroke-miterlimit:10;}\r\n\t.st11{opacity:0.39;}\r\n\t.st12{clip-path:url(#SVGID_2_);}\r\n\t.st13{clip-path:url(#SVGID_4_);}\r\n\t.st14{fill:none;stroke:#000000;stroke-width:0.1073;}\r\n\t.st15{clip-path:url(#SVGID_6_);}\r\n\t.st16{clip-path:url(#SVGID_8_);}\r\n\t.st17{clip-path:url(#SVGID_10_);}\r\n\t.st18{clip-path:url(#SVGID_12_);}\r\n\t.st19{clip-path:url(#SVGID_14_);}\r\n\t.st20{clip-path:url(#SVGID_16_);}\r\n\t.st21{clip-path:url(#SVGID_18_);}\r\n\t.st22{clip-path:url(#SVGID_20_);}\r\n\t.st23{clip-path:url(#SVGID_22_);}\r\n\t.st24{clip-path:url(#SVGID_24_);}\r\n\t.st25{clip-path:url(#SVGID_26_);}\r\n\t.st26{clip-path:url(#SVGID_28_);}\r\n\t.st27{clip-path:url(#SVGID_30_);}\r\n\t.st28{clip-path:url(#SVGID_32_);}\r\n\t.st29{clip-path:url(#SVGID_34_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.08
    },
    width: 575,
    height: 575,
    xlinkHref: "E889EA3F.png",
    transform: "matrix(8.582133e-02 0 0 8.582133e-02 0.8432 1.0564)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 25,
    cy: 24.6,
    r: 23.6
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 25,
    cy: 24.6,
    r: 23.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 45,
    y: -15.1,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 50,
    y1: 5.1,
    x2: 50,
    y2: 25.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 44.9,
    y1: 0.1,
    x2: 65.3,
    y2: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 50,
    y1: -15.2,
    x2: 50,
    y2: 5.3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 24.6,
    y1: 0.1,
    x2: 45,
    y2: 0.1
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 45,
    y: 5.2,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 50,
    y1: 25.4,
    x2: 50,
    y2: 45.8
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 65.3,
    y1: 10.3,
    x2: 44.9,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 44.9,
    y1: 20.4,
    x2: 65.3,
    y2: 20.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 50,
    y1: 5.1,
    x2: 50,
    y2: 25.6
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 45,
    y1: 10.3,
    x2: 24.6,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 24.6,
    y1: 20.4,
    x2: 45,
    y2: 20.4
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 50,
    y1: -15.2,
    x2: 50,
    y2: 5.3
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 45,
    y: 25.5,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 50,
    y1: 45.6,
    x2: 50,
    y2: 66.1
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 65.3,
    y1: 30.5,
    x2: 44.9,
    y2: 30.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 44.9,
    y1: 40.7,
    x2: 65.3,
    y2: 40.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 50,
    y1: 25.4,
    x2: 50,
    y2: 45.8
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 45,
    y1: 30.5,
    x2: 24.6,
    y2: 30.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 24.6,
    y1: 40.7,
    x2: 45,
    y2: 40.7
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 50,
    y1: 5.1,
    x2: 50,
    y2: 25.6
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 45,
    y: 45.7,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 65.3,
    y1: 50.8,
    x2: 44.9,
    y2: 50.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 50,
    y1: 45.6,
    x2: 50,
    y2: 66.1
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 45,
    y1: 50.8,
    x2: 24.6,
    y2: 50.8
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 50,
    y1: 25.4,
    x2: 50,
    y2: 45.8
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: 24.7,
    y: -15.1,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 39.9,
    y1: 25.6,
    x2: 39.9,
    y2: 5.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 29.8,
    y1: 5.1,
    x2: 29.8,
    y2: 25.6
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 44.9,
    y1: 0.1,
    x2: 65.3,
    y2: 0.1
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 24.6,
    y1: 0.1,
    x2: 45,
    y2: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 39.9,
    y1: 5.3,
    x2: 39.9,
    y2: -15.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 29.8,
    y1: -15.2,
    x2: 29.8,
    y2: 5.3
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 4.3,
    y1: 0.1,
    x2: 24.8,
    y2: 0.1
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: 24.7,
    y: 5.2,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 39.9,
    y1: 45.8,
    x2: 39.9,
    y2: 25.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 29.8,
    y1: 25.4,
    x2: 29.8,
    y2: 45.8
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 65.3,
    y1: 10.3,
    x2: 44.9,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 44.9,
    y1: 20.4,
    x2: 65.3,
    y2: 20.4
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 45,
    y1: 10.3,
    x2: 24.6,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 24.6,
    y1: 20.4,
    x2: 45,
    y2: 20.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 39.9,
    y1: 25.6,
    x2: 39.9,
    y2: 5.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 29.8,
    y1: 5.1,
    x2: 29.8,
    y2: 25.6
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 24.8,
    y1: 10.3,
    x2: 4.3,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 4.3,
    y1: 20.4,
    x2: 24.8,
    y2: 20.4
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 39.9,
    y1: 5.3,
    x2: 39.9,
    y2: -15.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 29.8,
    y1: -15.2,
    x2: 29.8,
    y2: 5.3
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: 24.7,
    y: 25.5,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 39.9,
    y1: 66.1,
    x2: 39.9,
    y2: 45.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 29.8,
    y1: 45.6,
    x2: 29.8,
    y2: 66.1
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 65.3,
    y1: 30.5,
    x2: 44.9,
    y2: 30.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 44.9,
    y1: 40.7,
    x2: 65.3,
    y2: 40.7
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 45,
    y1: 30.5,
    x2: 24.6,
    y2: 30.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 24.6,
    y1: 40.7,
    x2: 45,
    y2: 40.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 39.9,
    y1: 45.8,
    x2: 39.9,
    y2: 25.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 29.8,
    y1: 25.4,
    x2: 29.8,
    y2: 45.8
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 24.8,
    y1: 30.5,
    x2: 4.3,
    y2: 30.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 4.3,
    y1: 40.7,
    x2: 24.8,
    y2: 40.7
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 39.9,
    y1: 25.6,
    x2: 39.9,
    y2: 5.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 29.8,
    y1: 5.1,
    x2: 29.8,
    y2: 25.6
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: 24.7,
    y: 45.7,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 65.3,
    y1: 50.8,
    x2: 44.9,
    y2: 50.8
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 45,
    y1: 50.8,
    x2: 24.6,
    y2: 50.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 39.9,
    y1: 66.1,
    x2: 39.9,
    y2: 45.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 29.8,
    y1: 45.6,
    x2: 29.8,
    y2: 66.1
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 24.8,
    y1: 50.8,
    x2: 4.3,
    y2: 50.8
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 39.9,
    y1: 45.8,
    x2: 39.9,
    y2: 25.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 29.8,
    y1: 25.4,
    x2: 29.8,
    y2: 45.8
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: 4.4,
    y: -15.1,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 19.6,
    y1: 25.6,
    x2: 19.6,
    y2: 5.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 9.5,
    y1: 5.1,
    x2: 9.5,
    y2: 25.6
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 24.6,
    y1: 0.1,
    x2: 45,
    y2: 0.1
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 4.3,
    y1: 0.1,
    x2: 24.8,
    y2: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 19.6,
    y1: 5.3,
    x2: 19.6,
    y2: -15.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 9.5,
    y1: -15.2,
    x2: 9.5,
    y2: 5.3
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: -15.9,
    y1: 0.1,
    x2: 4.5,
    y2: 0.1
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_21_",
    x: 4.4,
    y: 5.2,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 19.6,
    y1: 45.8,
    x2: 19.6,
    y2: 25.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 9.5,
    y1: 25.4,
    x2: 9.5,
    y2: 45.8
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 45,
    y1: 10.3,
    x2: 24.6,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 24.6,
    y1: 20.4,
    x2: 45,
    y2: 20.4
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 24.8,
    y1: 10.3,
    x2: 4.3,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 4.3,
    y1: 20.4,
    x2: 24.8,
    y2: 20.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 19.6,
    y1: 25.6,
    x2: 19.6,
    y2: 5.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 9.5,
    y1: 5.1,
    x2: 9.5,
    y2: 25.6
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 4.5,
    y1: 10.3,
    x2: -15.9,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: -15.9,
    y1: 20.4,
    x2: 4.5,
    y2: 20.4
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 19.6,
    y1: 5.3,
    x2: 19.6,
    y2: -15.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 9.5,
    y1: -15.2,
    x2: 9.5,
    y2: 5.3
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: 4.4,
    y: 25.5,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 19.6,
    y1: 66.1,
    x2: 19.6,
    y2: 45.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 9.5,
    y1: 45.6,
    x2: 9.5,
    y2: 66.1
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 45,
    y1: 30.5,
    x2: 24.6,
    y2: 30.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 24.6,
    y1: 40.7,
    x2: 45,
    y2: 40.7
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 24.8,
    y1: 30.5,
    x2: 4.3,
    y2: 30.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 4.3,
    y1: 40.7,
    x2: 24.8,
    y2: 40.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 19.6,
    y1: 45.8,
    x2: 19.6,
    y2: 25.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 9.5,
    y1: 25.4,
    x2: 9.5,
    y2: 45.8
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 4.5,
    y1: 30.5,
    x2: -15.9,
    y2: 30.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: -15.9,
    y1: 40.7,
    x2: 4.5,
    y2: 40.7
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 19.6,
    y1: 25.6,
    x2: 19.6,
    y2: 5.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 9.5,
    y1: 5.1,
    x2: 9.5,
    y2: 25.6
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    x: 4.4,
    y: 45.7,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 45,
    y1: 50.8,
    x2: 24.6,
    y2: 50.8
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 24.8,
    y1: 50.8,
    x2: 4.3,
    y2: 50.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 19.6,
    y1: 66.1,
    x2: 19.6,
    y2: 45.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 9.5,
    y1: 45.6,
    x2: 9.5,
    y2: 66.1
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 4.5,
    y1: 50.8,
    x2: -15.9,
    y2: 50.8
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 19.6,
    y1: 45.8,
    x2: 19.6,
    y2: 25.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 9.5,
    y1: 25.4,
    x2: 9.5,
    y2: 45.8
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: -15.9,
    y: -15.1,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    className: "st26"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 4.3,
    y1: 0.1,
    x2: 24.8,
    y2: 0.1
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    className: "st26"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: -15.9,
    y1: 0.1,
    x2: 4.5,
    y2: 0.1
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_29_",
    x: -15.9,
    y: 5.2,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 24.8,
    y1: 10.3,
    x2: 4.3,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 4.3,
    y1: 20.4,
    x2: 24.8,
    y2: 20.4
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 4.5,
    y1: 10.3,
    x2: -15.9,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: -15.9,
    y1: 20.4,
    x2: 4.5,
    y2: 20.4
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_31_",
    x: -15.9,
    y: 25.5,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    className: "st28"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 24.8,
    y1: 30.5,
    x2: 4.3,
    y2: 30.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 4.3,
    y1: 40.7,
    x2: 24.8,
    y2: 40.7
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    className: "st28"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 4.5,
    y1: 30.5,
    x2: -15.9,
    y2: 30.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: -15.9,
    y1: 40.7,
    x2: 4.5,
    y2: 40.7
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_33_",
    x: -15.9,
    y: 45.7,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    className: "st29"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 24.8,
    y1: 50.8,
    x2: 4.3,
    y2: 50.8
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    className: "st29"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 4.5,
    y1: 50.8,
    x2: -15.9,
    y2: 50.8
  }))))))))))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.2,30.4c0,0,11.1,0.9,16.2,0s16.2,0,16.2,0"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M25.5,40.3c-11.8,0-16.3-9.3-16.3-9.4l0.3-0.1c0,0.1,4.4,9.2,16,9.2c11.6,0,16-9.1,16-9.2l0.3,0.1 C41.8,30.9,37.3,40.3,25.5,40.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M25.5,40.8L25.5,40.8c-12.1,0-16.7-9.6-16.8-9.7l-0.2-0.5L9.8,30l0.2,0.4c0,0.1,4.4,8.9,15.5,8.9 c11.2,0,15.5-8.9,15.5-8.9l0.2-0.4l1.2,0.6L42.3,31C42.3,31.1,37.6,40.8,25.5,40.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M21.2,25.3c0,0-1.5-3.6-3.3-3.6c-1.7,0-3.2,3.6-3.3,3.6l-0.3-0.1c0.1-0.2,1.6-3.8,3.6-3.8 c2,0,3.5,3.7,3.6,3.8L21.2,25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M14.9,26l-1.3-0.5l0.2-0.5c0.2-0.4,1.8-4.1,4.1-4.1s3.9,3.7,4.1,4.1l0.2,0.5L20.9,26l-0.2-0.5 c-0.6-1.3-1.8-3.3-2.8-3.3c-1.1,0-2.4,2.2-2.8,3.3L14.9,26z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M36.4,25.3c0,0-1.5-3.6-3.3-3.6c-1.7,0-3.2,3.6-3.3,3.6l-0.3-0.1c0.1-0.2,1.6-3.8,3.6-3.8 c2,0,3.5,3.7,3.6,3.8L36.4,25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M36.2,26L36,25.5c-0.4-1.1-1.7-3.3-2.8-3.3c-1.1,0-2.4,2.2-2.8,3.3L30.2,26l-1.3-0.5l0.2-0.5 c0.2-0.4,1.8-4.1,4.1-4.1s3.9,3.7,4.1,4.1l0.2,0.5L36.2,26z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyt03);
export default __webpack_public_path__ + "static/media/smileyt-03.5ddd11c42756662741f2665ebe944925.svg";
export { ForwardRef as ReactComponent };